import { Table } from 'antd';
import { stringDate } from '../../../../../util';
import { formatPrice } from '../../../../../util/formatPrice';

export const ConsignProducts = ({ data = {} }) => {
  const { consignmentOrderProduct = [] } = data;

  const columns = [
    {
      title: 'Producto',
      dataIndex: 'product',
      key: 'product',
      render: (product) => product?.name || '-',
    },
    {
      title: 'Cantidad',
      dataIndex: 'quantity',
      key: 'quantity',
    },
    {
      title: 'Lote',
      dataIndex: 'allotment',
      key: 'allotment',
      render: (allotment) => allotment || '-',
    },
    {
      title: 'Precio',
      dataIndex: 'price',
      key: 'price',
      render: (price) => `${formatPrice(price)}`,
    },
    {
      title: 'Expiración',
      dataIndex: 'expiresAt',
      key: 'expiresAt',
      render: (date) => (date ? stringDate(date) : '—'),
    },
  ];

  return (
    <Table
      dataSource={consignmentOrderProduct}
      columns={columns}
      rowKey={(row) => row.id}
      pagination={{
        defaultPageSize: 10,
        pageSizeOptions: [10, 20, 40, 60],
      }}
    />
  );
};
